import React, { useEffect, useState } from "react";
import Man from "../../../../../../assets/images/Souvenir/3201.png";
import Men from "../../../../../../assets/images/Souvenir/bid.png";
import LiveIcon from "../../../../../../assets/images/Souvenir/live.png";
import Nodata from "../../../../../../assets/Icon/Nodata.png";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import AuctionNav from "./AuctionNav/AuctionNav";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";
import ProductCard from "./Content/ProductCard";

const UnSoldProductList = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [unSoldProduct, setUnSoldProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/unSold/auction/product`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setUnSoldProduct(res.data.unsold_product);
      }
    });
  }, []);

  return (
    <>
      <AuctionNav />

      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>
        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
          Unsold Product
        </div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCard data={unSoldProduct} noBidder="true" />
      )}
    </>
  );
};

export default UnSoldProductList;
